import { useReducer, useEffect, useCallback } from 'react';
import { modalsReducer } from '@/reducers/workspaceLayoutModalsReducer';
import { useSearchParams } from 'react-router-dom';
import { ModalsReducerPayload } from '@/types/reducers';

export const useWorkspaceModals = (
  setNewlyCreatedOrganizationAsLocalSelectedOrganization: (id: string) => void,
) => {
  const [searchParams] = useSearchParams();
  const forceCreateOrganization = searchParams.has('priceId');
  const newlyCreatedOrganization = searchParams.has('newlyCreatedOrganizationId');

  const [isOpen, dispatch] = useReducer(modalsReducer, {
    newEntityModal: false,
    switchWorkspaceModal: false,
    switchOrganizationModal: false,
    userProfileModal: false,
    newOrganizationModal: forceCreateOrganization && !newlyCreatedOrganization,
  });

  useEffect(() => {
    if (
      !isOpen.newOrganizationModal &&
      forceCreateOrganization &&
      !searchParams.has('newlyCreatedOrganizationId')
    ) {
      dispatch({ payload: 'newOrganizationModal', type: 'OPEN' });
    }
    if (
      !isOpen.switchWorkspaceModal &&
      searchParams.has('newlyCreatedOrganizationId') &&
      !searchParams.has('priceId')
    ) {
      setNewlyCreatedOrganizationAsLocalSelectedOrganization(
        searchParams.get('newlyCreatedOrganizationId') as string,
      );
      dispatch({ payload: 'switchWorkspaceModal', type: 'OPEN' });
    }
  }, [
    forceCreateOrganization,
    isOpen.newOrganizationModal,
    isOpen.switchWorkspaceModal,
    searchParams,
    setNewlyCreatedOrganizationAsLocalSelectedOrganization,
  ]);

  const handleCloseModal = useCallback(() => {
    dispatch({ type: 'CLOSE', payload: 'switchWorkspaceModal' });
  }, []);

  const handleOpenNewWorkspaceModal = () => {
    dispatch({ type: 'OPEN', payload: 'newEntityModal' });
  };

  const openModal = (modalName: ModalsReducerPayload) => {
    dispatch({ type: 'OPEN', payload: modalName });
  };

  const closeModal = (modalName: ModalsReducerPayload) => {
    dispatch({ type: 'CLOSE', payload: modalName });
  };

  return {
    isOpen,
    dispatch,
    handleCloseModal,
    handleOpenNewWorkspaceModal,
    openModal,
    closeModal,
  };
};
